import { createContext } from 'react';

const SelectedStationInfoContext = createContext({
  SelectedStationInfoDisplay: true,
});
export default SelectedStationInfoContext;
